import { render, staticRenderFns } from "./CarePlanModuleHub.vue?vue&type=template&id=5b649847&scoped=true"
import script from "./CarePlanModuleHub.vue?vue&type=script&lang=js"
export * from "./CarePlanModuleHub.vue?vue&type=script&lang=js"
import style0 from "./CarePlanModuleHub.vue?vue&type=style&index=0&id=5b649847&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b649847",
  null
  
)

export default component.exports